export const SERVICE_URL = process.env.SERVICE_URL;

export const ACTION_ADD_ALERT = "ACTION_ADD_ALERT";
export const ACTION_DISMISS_ALERT = "ACTION_DISMISS_ALERT";
export const ACTION_SET_BUSY = "ACTION_SET_BUSY";
export const ACTION_SET_CATEGORY = "ACTION_SET_CATEGORY";
export const ACTION_SET_CHARITIES = "ACTION_SET_CHARITIES";

export const ALERT_TYPE_ERROR = "Error";
export const ALERT_TYPE_SUCCESS = "Success";
